import { Box, Typography } from '@mui/material'
import styles from "../../assets/styles/componentStyles/utility/consultation.module.scss";
import { useContext,  } from 'react';
import { UserContext, UserContextPayload } from '../../context/userContext';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import agent from '../../services/api';
import { primaryColor } from '../../utils/colors';
interface consultationComponent {
    flagInsideSideNavigationPanel?: boolean;
    flagMobile?: boolean;
    onClickConsultation?: () => void;
    onCloseConsultation?: () => void
}
export const DelegateAccess = (props: consultationComponent) => {
    const { userDetail, handleError } = useContext(UserContext) as UserContextPayload

    async function exitDeletageAccess() {
        const response = await agent.removeDelegateAccess.delete()
        if (response.status) {
            window.close()
        } else {
            handleError(response);
        }
    }
    return (
        <>
            {userDetail.user_delegate_access_data &&
                <>
                    {(userDetail.user_delegate_access_data) &&
                        <>
                            <Box className={props.flagMobile ? styles.mainBlockMobile : styles.mainBlock} onClick={() => { exitDeletageAccess() }}>
                                <Box className={styles.mainBlockChild}>
                                    <ExitToAppIcon sx={{ color: primaryColor }} />
                                    {!props.flagMobile &&
                                        <Typography className={styles.nameStyle} sx={{ maxWidth: "125px", overflow: "hidden", textOverflow: "ellipsis" }}>
                                            {userDetail.user_delegate_access_data?.user_email}
                                        </Typography>
                                    }
                                </Box>
                            </Box>
                        </>
                    }
                </>
            }
        </>
    )
}
